"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurvedArrowMarker = void 0;
var markerjs2_1 = require("markerjs2");
/**
 * This marker is a combination of the native CurveMarker and ArrowMarker. We extend the CurveMarker
 * and copy the contents of the ArrowMarker with some modifications.
 *
 * See https://github.com/ailon/markerjs2/blob/8b0c599aed812135424e62a168894b034d68b40b/src/markers/arrow-marker/ArrowMarker.ts
 */
var CurvedArrowMarker = /** @class */ (function (_super) {
    __extends(CurvedArrowMarker, _super);
    /**
     * Creates a new marker.
     *
     * @param container - SVG container to hold marker's visual.
     * @param overlayContainer - overlay HTML container to hold additional overlay elements while editing.
     * @param settings - settings object containing default markers settings.
     */
    function CurvedArrowMarker(container, overlayContainer, settings) {
        var _this = _super.call(this, container, overlayContainer, settings) || this;
        _this.arrow1 = undefined;
        _this.arrow2 = undefined;
        _this.arrowType = 'end';
        _this.arrowBaseHeight = 10;
        _this.arrowBaseWidth = 10;
        _this.getArrowPoints = _this.getArrowPoints.bind(_this);
        _this.setArrowType = _this.setArrowType.bind(_this);
        _this.arrowTypePanel = new markerjs2_1.ArrowTypePanel('Arrow type', 'end');
        _this.arrowTypePanel.onArrowTypeChanged = _this.setArrowType;
        return _this;
    }
    /**
     * Returns true if passed SVG element belongs to the marker. False otherwise.
     *
     * @param el - target element.
     */
    CurvedArrowMarker.prototype.ownsTarget = function (el) {
        return _super.prototype.ownsTarget.call(this, el) || el === this.arrow1 || el === this.arrow2;
    };
    CurvedArrowMarker.prototype.getArrowPoints = function (offsetX, offsetY) {
        var width = this.arrowBaseWidth + this.strokeWidth * 2;
        var height = this.arrowBaseHeight + this.strokeWidth * 2;
        return "".concat(offsetX - width / 2, ",").concat(offsetY + height / 2, " ").concat(offsetX, ",").concat(offsetY - height / 2, " ").concat(offsetX + width / 2, ",").concat(offsetY + height / 2);
    };
    CurvedArrowMarker.prototype.createTips = function () {
        this.arrow1 = markerjs2_1.SvgHelper.createPolygon(this.getArrowPoints(this.x1, this.y1), [
            ['fill', this.strokeColor],
        ]);
        this.arrow1.transform.baseVal.appendItem(markerjs2_1.SvgHelper.createTransform());
        this.visual.appendChild(this.arrow1);
        this.arrow2 = markerjs2_1.SvgHelper.createPolygon(this.getArrowPoints(this.x2, this.y2), [
            ['fill', this.strokeColor],
        ]);
        this.arrow2.transform.baseVal.appendItem(markerjs2_1.SvgHelper.createTransform());
        this.visual.appendChild(this.arrow2);
    };
    /**
     * Handles pointer (mouse, touch, stylus, etc.) down event.
     *
     * @param point - event coordinates.
     * @param target - direct event target element.
     */
    CurvedArrowMarker.prototype.pointerDown = function (point, target) {
        _super.prototype.pointerDown.call(this, point, target);
        if (this.state === 'creating') {
            this.createTips();
        }
    };
    /**
     * Adjusts marker visual after manipulation.
     *
     * The ArrowMarker uses the angle of (x1,y1) to (x2,y2) to calculate the angle of the arrow tip.
     * For our custom curved arrow marker, we need the third grab point that exists on the
     * CurveMarker. The angle on one end is (x1,y1) to (curveX, curveY), and the angle of the other
     * end is (x2,y2) to (curveX, curveY).
     *
     * See adjustVisual() of the ArrowMarker for reference:
     * https://github.com/ailon/markerjs2/blob/8b0c599aed812135424e62a168894b034d68b40b/src/markers/arrow-marker/ArrowMarker.ts#L112
     */
    CurvedArrowMarker.prototype.adjustVisual = function () {
        _super.prototype.adjustVisual.call(this);
        if (!this.arrow1 || !this.arrow2) {
            return;
        }
        this.arrow1.style.display =
            this.arrowType === 'both' || this.arrowType === 'start' ? '' : 'none';
        this.arrow2.style.display =
            this.arrowType === 'both' || this.arrowType === 'end' ? '' : 'none';
        markerjs2_1.SvgHelper.setAttributes(this.arrow1, [
            ['points', this.getArrowPoints(this.x1, this.y1)],
            ['fill', this.strokeColor],
        ]);
        markerjs2_1.SvgHelper.setAttributes(this.arrow2, [
            ['points', this.getArrowPoints(this.x2, this.y2)],
            ['fill', this.strokeColor],
        ]);
        var lineAngle1 = this.getAngleToCurvePoint(this.x1, this.y1);
        var lineAngle2 = this.getAngleToCurvePoint(this.x2, this.y2);
        this.transformArrowTip(this.arrow1, lineAngle1, this.x1, this.y1);
        this.transformArrowTip(this.arrow2, lineAngle2, this.x2, this.y2);
    };
    CurvedArrowMarker.prototype.getAngleToCurvePoint = function (x, y) {
        var _a = this.getState(), curveX = _a.curveX, curveY = _a.curveY;
        if (Math.abs(x - curveX) <= 0.1) {
            return 0;
        }
        return (Math.atan((curveY - y) / (curveX - x)) * 180) / Math.PI + 90 * Math.sign(x - curveX);
    };
    CurvedArrowMarker.prototype.transformArrowTip = function (arrow, angle, x, y) {
        var transform = arrow.transform.baseVal.getItem(0);
        transform.setRotate(angle, x, y);
        arrow.transform.baseVal.replaceItem(transform, 0);
    };
    CurvedArrowMarker.prototype.setArrowType = function (arrowType) {
        this.arrowType = arrowType;
        this.adjustVisual();
        this.stateChanged();
    };
    Object.defineProperty(CurvedArrowMarker.prototype, "toolboxPanels", {
        /**
         * Returns the list of toolbox panels for this marker type.
         */
        get: function () {
            return [this.strokePanel, this.strokeWidthPanel, this.arrowTypePanel];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns current marker state that can be restored in the future.
     */
    CurvedArrowMarker.prototype.getState = function () {
        return __assign(__assign({ arrowType: this.arrowType }, _super.prototype.getState.call(this)), { typeName: CurvedArrowMarker.typeName });
    };
    /**
     * Restores previously saved marker state.
     */
    CurvedArrowMarker.prototype.restoreState = function (state) {
        _super.prototype.restoreState.call(this, state);
        var amState = state;
        this.arrowType = amState.arrowType;
        this.createTips();
        this.adjustVisual();
    };
    CurvedArrowMarker.typeName = 'CurvedArrowMarker';
    CurvedArrowMarker.title = 'Curved arrow marker';
    return CurvedArrowMarker;
}(markerjs2_1.CurveMarker));
exports.CurvedArrowMarker = CurvedArrowMarker;
